module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content modal-success"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇藥物類別")]), _c('div', {
    staticClass: "group-wrapper"
  }, _vm._l((_vm.medGroups), function(group) {
    return _c('div', {
      staticClass: "group-button",
      on: {
        "click": function($event) {
          return _vm.selectGroup(group.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(group.name))])])
  }), 0), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104e5acd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/MedicineGroupSelect.vue
// module id = 1389
// module chunks = 1